import React, { useEffect, useState } from 'react';
import { InputLabel, makeStyles } from '@material-ui/core';
import Box from 'core/ui/Box';
import { ButtonCompetition } from 'core/ui/Button';
import { Movie } from '@material-ui/icons';
import Typography from 'core/ui/Typography';
import { useTranslation } from 'react-i18next';
import { primary, secondary } from 'core/ui/Colors';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';
import Uploading from './Uploading';

const UploadMobile = ({ bgColor, setUploadModal, compButtonColor, web }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [upload, setUpload] = useState({});
  const [buttonColor, setButtonColor] = useState(compButtonColor);
  const useStyles = makeStyles(() => {
    return {
      root: {
        backgroundColor: bgColor || secondary,
        minHeight: '120px',
      },
    };
  });
  const classes = useStyles();

  useEffect(() => {
    const parsed = parse(location.search);
    if (parsed && parsed.buttonColor && !compButtonColor) {
      setButtonColor(parsed.buttonColor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (compButtonColor) {
      setButtonColor(compButtonColor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compButtonColor]);

  useEffect(() => {
    if (setUploadModal) {
      setUploadModal((prev) => ({ ...prev, ...upload }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upload]);

  const handleCapture = ({ target }) => {
    if (target.files.length) {
      const file = target.files[0];
      setUpload((prev) => ({ ...prev, open: true, file }));
    }
  };

  const randomId = Math.floor(Math.random() * 101);

  return (
    <Box p={5} className={classes.root}>
      {!upload.open && (
        <Box display="flex" justifyContent="center" className="link-hover">
          <ButtonCompetition
            style={{
              borderRadius: 5,
              backgroundColor: `#${(buttonColor || '').replace('#', '')}` || primary,
            }}
            color="primary"
            variant="contained"
          >
            <InputLabel htmlFor={`icon-button-file-${randomId}`}>
              <Box display="flex" alignItems="center" justifyContent="center" p={3}>
                <Movie size="small" style={{ color: web ? secondary : 'white' }} />
                <Typography ml={3} style={{ color: 'white' }} variant="subtitle2">
                  {upload.file && upload.file.name
                    ? `${t('workout.uploading')} ${upload.file.name}`
                    : t('workout.upload.selectVideo')}
                </Typography>
              </Box>
            </InputLabel>
          </ButtonCompetition>
        </Box>
      )}

      {upload.open && (
        <Uploading
          buttonColor={buttonColor ? `#${buttonColor}` : primary}
          upload={upload}
          setUpload={setUpload}
          web={web}
        />
      )}

      <input
        color="primary"
        type="file"
        onChange={handleCapture}
        id={`icon-button-file-${randomId}`}
        style={{ display: 'none' }}
        accept=".mpeg,.mp4,.avi,.mov,.webm,.flv"
        multiple
      />
    </Box>
  );
};

UploadMobile.propTypes = {};

export default UploadMobile;
